import { configureStore } from "@reduxjs/toolkit";
import market from "./slices/market/marketSlice";
import user from "./slices/user/userSlice";
import wallet from "./slices/wallet/walletSlice";
import trade from "./slices/trade/tradeSlice";
import portfolio from "./slices/portfolio/portfolioSlice";
import borrow from "./slices/borrow/borrowSlice";
import repay from "./slices/repay/repaySlice";

export const store = configureStore({
  reducer: { user, wallet, market, trade, portfolio, borrow, repay },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
